import { render, staticRenderFns } from "./tabList.vue?vue&type=template&id=bb50bb80&scoped=true"
import script from "./tabList.vue?vue&type=script&lang=js"
export * from "./tabList.vue?vue&type=script&lang=js"
import style0 from "./tabList.vue?vue&type=style&index=0&id=bb50bb80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb50bb80",
  null
  
)

export default component.exports